import React, { useState } from 'react'
import banner from 'assets/images/invite-friends-banner.png'
import InviteFriendsModal from 'components/InviteFriendsModal'
import BannerCardSection from 'components/sections/BannerCardSection'

const InviteFriendSection = () => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  return (
    <>
      <BannerCardSection
        bannerImage={banner}
        altText="White villas, green trees on a mountain range and the bright blue sea"
        subtitle="Invite a Friend"
        heading="Invite a friend to A.M.A Sections & receive up to 500€ in travel credit!"
        content="Create an account with A.M.A Selections and stay up to date with the latest properties, destinations, and special offer. Become a member and gain up to 2% loyaly credit to be used towards future bookings with us."
        buttonText="Invite Now"
        buttonAction={() => setIsModalOpen(true)}
      />

      <InviteFriendsModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  )
}

export default InviteFriendSection
